export default [

     {
          path: '/risk',
          name: 'Risk',
          component: () => import("@/views/Page/Risk/Risk.vue"),
           meta: {
               title: 'Risk',
          },
     },
     {
          path: '/risk/:id',
          name: 'RiskView',
          props: true,
          component: () => import("@/views/Page/Risk/RiskView.vue"),
          meta: {
              title: 'Risk Detail',
          },
     },
       {
          path: '/risk/control-status',
          name: 'RiskControlStatus',
          props: true,
          component: () => import("@/views/Page/Risk/RiskControlStatus.vue"),
          meta: {
              title: 'Risk Control Status',
          },
     }
];